import { useMemo } from 'react';

import {
  useShowConsumerCampaignById,
  useShowConsumerCampaignSettingsById,
} from '@givebacks/api/store';
import { useNavigate } from 'react-router-dom';
import { Card, Flex, Stack, Text, Title } from 'ui';
import { ArrowRightIcon } from 'ui/Icons';

import { useDonorTranslations } from '../../../Context';
import { useCampaignInfoByProvider } from '../../../api/new/campaigns/utils/campaignUtils';

export const StudentCenterButton = () => {
  const { causeId, campaignId } = useCampaignInfoByProvider();
  const { data: campaign, isLoading } = useShowConsumerCampaignById({ causeId, campaignId });
  const { t } = useDonorTranslations();
  const navigate = useNavigate();
  const { data: campaignSettings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });
  const { isTeamsEnabled, isParticipantsEnabled, isRegistrationOpen } = campaignSettings ?? {};

  const buttonText = useMemo(() => {
    switch (true) {
      case isTeamsEnabled && isParticipantsEnabled && isRegistrationOpen: {
        return ` Visit our ${campaign?.participant_options.title} to register a ${t(
          'participant'
        ).toLowerCase()} or search for ${t('participants').toLowerCase()} and ${t(
          'teams'
        ).toLowerCase()}.`;
      }
      case isTeamsEnabled && isParticipantsEnabled && !isRegistrationOpen: {
        return ` Visit our ${campaign?.participant_options.title} to search for ${t(
          'participants'
        ).toLowerCase()} and ${t('teams').toLowerCase()}.`;
      }
      case !isTeamsEnabled && isParticipantsEnabled && isRegistrationOpen: {
        return ` Visit our ${campaign?.participant_options.title} to register or search for ${t(
          'participants'
        ).toLowerCase()}.`;
      }
      case !isTeamsEnabled && isParticipantsEnabled && !isRegistrationOpen: {
        return ` Visit our ${campaign?.participant_options.title} to search for ${t(
          'participants'
        ).toLowerCase()}.`;
      }
      case isTeamsEnabled && !isParticipantsEnabled: {
        return ` Visit our ${campaign?.participant_options.title} to search for ${t(
          'teams'
        ).toLowerCase()}.`;
      }
      default: {
        return null;
      }
    }
  }, [
    campaign?.participant_options.title,
    isParticipantsEnabled,
    isRegistrationOpen,
    isTeamsEnabled,
    t,
  ]);

  if (isLoading) return null;
  return (
    <Card
      shadow={'md'}
      style={(theme) => ({
        cursor: 'pointer',
        border: `1px solid ${theme?.colors.cobalt[0]}`,
      })}
      onClick={() => navigate('participant-center')}
    >
      <Flex align={'center'} gap="md" justify="space-between">
        <Stack gap={4}>
          <Title order={4} style={{ textTransform: 'capitalize' }}>
            {campaign?.participant_options.title}
          </Title>
          <Text type="sub">{buttonText}</Text>
        </Stack>
        <ArrowRightIcon className="w-5 h-5" />
      </Flex>
    </Card>
  );
};
